import { render } from "./detailForTemporary.vue?vue&type=template&id=0d1aef18&ts=true"
import script from "./detailForTemporary.vue?vue&type=script&lang=ts&config=true"
export * from "./detailForTemporary.vue?vue&type=script&lang=ts&config=true"

import "./detailForTemporary.vue?vue&type=style&index=0&id=0d1aef18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__